import { BaseModel } from '@red/data-access';
import { Expose } from 'class-transformer';
import { IAccountType } from './../interfaces/account-type.interface';
export class AccountType extends BaseModel implements IAccountType {
  @Expose()
  type!: string;
}
